import { Typography } from '@mui/material';

import { tApp } from '@frontend/locales';

export interface ViewAllActionProps {
  onClick: () => void;
  href?: string;
}

export const ViewAllAction = (props: ViewAllActionProps) => {
  return (
    <Typography
      variant="body2"
      component="a"
      onClick={(e) => {
        e.preventDefault();
        props.onClick();
      }}
      href={props.href}
      ml={1}
      flexShrink={0}
      sx={{
        color: 'inherit',
        textDecoration: 'none',
      }}
    >
      {tApp.actions.viewAll()}
    </Typography>
  );
};
